export default [
  {
    prop: 'month',
    label: '月份',
    minWidth: 100,
    tooltip: true
  },
  {
    prop: 'channel_name',
    label: '签约主体',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'work_price',
    label: '消耗金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'zfb_price',
    label: '支付宝金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'wx_price',
    label: '微信金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'rate',
    label: '服务费率',
    minWidth: 100,
    tooltip: true
  },
  {
    prop: 'service_price',
    label: '服务费',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'rcon_price',
    label: '对账金额',
    minWidth: 140,
    tooltip: true
  },
  {
    prop: 'start_day',
    label: '对账周期',
    minWidth: 190,
    tooltip: true
  },
  {
    prop: 'send_time',
    label: '发起时间',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'type',
    label: '发起类型',
    minWidth: 100
  },
  {
    prop: 'action',
    width: '150px',
    label: '操作'
  }
]
